module.exports = "/_next/static/images/ff219dc75670bbe919ec3a60ee532860-amazon-prime-day-desktop.jpg";